import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "../primitives/Reveal";

export const CTABand = () => {
    const { t } = useTranslation();
    return (
        <section className="bg-limestone-100 px-5 py-20 lg:px-8 lg:py-28" data-testid="cta-band">
            <Reveal>
                <div
                    className="bg-madder-grain relative mx-auto max-w-[1320px] overflow-hidden rounded-hero px-7 py-16 text-white lg:px-20 lg:py-24 shadow-pop"
                >
                    {/* Souq yellow corner block */}
                    <div className="absolute top-0 end-0 h-32 w-32 lg:h-44 lg:w-44 bg-souq-400" aria-hidden="true" />
                    <div className="absolute top-0 end-0 h-32 w-32 lg:h-44 lg:w-44 flex items-center justify-center" aria-hidden="true">
                        <span className="font-display font-extrabold text-ink-900 text-[48px] lg:text-[72px] leading-none">.sa</span>
                    </div>

                    {/* Asir stripe accent — bottom */}
                    <div className="asir-stripe absolute inset-x-0 bottom-0 h-2" aria-hidden="true" />

                    <div className="relative max-w-2xl">
                        <p className="text-[14px] font-bold uppercase tracking-[0.2em] text-souq-300">
                            {t("home.ctaBand.kicker")}
                        </p>
                        <h2 className="mt-5 font-display text-[42px] sm:text-[56px] lg:text-[72px] font-extrabold leading-[0.98] tracking-[-0.03em]">
                            {t("home.ctaBand.title")}{" "}
                            <span className="text-souq-400">{t("home.ctaBand.titleAccent")}</span>
                        </h2>
                        <p className="mt-7 max-w-xl text-[20px] leading-relaxed text-madder-100 font-medium">
                            {t("home.ctaBand.subtitle")}
                        </p>

                        <div className="mt-9 flex flex-wrap items-center gap-3">
                            <Link
                                to="/home-a#hero-search"
                                onClick={() => setTimeout(() => {
                                    document.getElementById("hero-search")?.querySelector("input")?.focus();
                                }, 400)}
                                data-testid="cta-band-primary"
                                className="group inline-flex min-h-[60px] items-center gap-2 rounded-btn bg-white px-7 text-[17px] font-bold text-madder-500 transition-all duration-200 ease-nour hover:bg-souq-400 hover:text-ink-900 active:translate-y-[1px]"
                            >
                                {t("home.ctaBand.primary")}
                                <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5 rtl-mirror" />
                            </Link>
                            <Link
                                to="#"
                                data-testid="cta-band-secondary"
                                className="inline-flex min-h-[60px] items-center gap-2 rounded-btn border-2 border-white/50 bg-transparent px-6 text-[17px] font-bold text-white transition-all duration-200 ease-nour hover:border-white hover:bg-white/10"
                            >
                                <MessageCircle className="h-5 w-5" />
                                {t("home.ctaBand.secondary")}
                            </Link>
                        </div>
                    </div>
                </div>
            </Reveal>
        </section>
    );
};
